import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdatePerson = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ personId, name }: { personId: string; name: string }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { name },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons/${personId}`,
        fetchConfig,
      );

      if (!response.ok) {
        throw new Error('Failed to update entity');
      }

      return response.json();
    },
    onSuccess: () => {
      trackCustomEvent(TrackingEventsV2.PersonUpdate, { matterId });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetPersons, { subsetId }] });
      toast.success('Entity updated');
    },
    onError: () => {
      toast.error('Failed to update entity');
    },
  });
};
